import React from 'react';
import { useState, forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { border, shadow, color, background } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '../grid/Grid';
import DEFAULT_COVER from './defaultCover.jpg';

const FIT_MAP = {
  cover: 'cover',
  contain: 'contain',
};

const fitStyle = css`
  overflow: hidden;
  object-fit: ${props => FIT_MAP[props.fit]};
`;

const StyledImage = styled.img`
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  ${border}
  ${shadow}
  ${color}
  ${background}
  ${props => props.fit && fitStyle}
`;

export const Image = forwardRef(({ src, fallbackSrc, onError, ...props }, ref) => {
  const [imageMissing, setImageMissing] = useState(false);
  const handleError = event => {
    if (onError) {
      onError(event);
    }
    setImageMissing(true);
  };
  return (
    <Box
      {...props}
      as={StyledImage}
      ref={ref}
      src={!imageMissing ? src : fallbackSrc}
      onError={(onError || fallbackSrc) && handleError}
    />
  );
});

Image.defaultProps = {
  fit: 'cover',
  fallbackSrc: DEFAULT_COVER,
  alt: '',
};

Image.displayName = 'Image';
